export default __webpack_public_path__ + "bark-logo.04355099a25b3c8452f2c041e404eec4.png";